module.exports = __webpack_public_path__ + "fonts/Rubik-500-latin24.5c13804.woff2";